/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApplyUserPasswordResetRequest,
    ApplyUserPasswordResetRequestFromJSON,
    ApplyUserPasswordResetRequestToJSON,
    CreateUserPasswordResetRequest,
    CreateUserPasswordResetRequestFromJSON,
    CreateUserPasswordResetRequestToJSON,
    SignOutRequest,
    SignOutRequestFromJSON,
    SignOutRequestToJSON,
    UserSignInRequest,
    UserSignInRequestFromJSON,
    UserSignInRequestToJSON,
} from '../models';

export interface UserApplyNewPasswordRequest {
    token: string;
    applyUserPasswordResetRequest: ApplyUserPasswordResetRequest;
}

export interface UserRequestPasswordResetRequest {
    createUserPasswordResetRequest: CreateUserPasswordResetRequest;
}

export interface UserSignInOperationRequest {
    userSignInRequest: UserSignInRequest;
}

export interface UserSignOutRequest {
    signOutRequest: SignOutRequest;
}

/**
 * 
 */
export class UserSessionsApi extends runtime.BaseAPI {

    /**
     */
    async userApplyNewPasswordRaw(requestParameters: UserApplyNewPasswordRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.token === null || requestParameters.token === undefined) {
            throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling userApplyNewPassword.');
        }

        if (requestParameters.applyUserPasswordResetRequest === null || requestParameters.applyUserPasswordResetRequest === undefined) {
            throw new runtime.RequiredError('applyUserPasswordResetRequest','Required parameter requestParameters.applyUserPasswordResetRequest was null or undefined when calling userApplyNewPassword.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/users/sessions/reset-passwords/{token}`.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters.token))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ApplyUserPasswordResetRequestToJSON(requestParameters.applyUserPasswordResetRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApplyNewPassword(token: string, applyUserPasswordResetRequest: ApplyUserPasswordResetRequest): Promise<void> {
        await this.userApplyNewPasswordRaw({ token: token, applyUserPasswordResetRequest: applyUserPasswordResetRequest });
    }

    /**
     */
    async userRequestPasswordResetRaw(requestParameters: UserRequestPasswordResetRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.createUserPasswordResetRequest === null || requestParameters.createUserPasswordResetRequest === undefined) {
            throw new runtime.RequiredError('createUserPasswordResetRequest','Required parameter requestParameters.createUserPasswordResetRequest was null or undefined when calling userRequestPasswordReset.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/users/sessions/reset-passwords`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUserPasswordResetRequestToJSON(requestParameters.createUserPasswordResetRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userRequestPasswordReset(createUserPasswordResetRequest: CreateUserPasswordResetRequest): Promise<void> {
        await this.userRequestPasswordResetRaw({ createUserPasswordResetRequest: createUserPasswordResetRequest });
    }

    /**
     */
    async userSignInRaw(requestParameters: UserSignInOperationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userSignInRequest === null || requestParameters.userSignInRequest === undefined) {
            throw new runtime.RequiredError('userSignInRequest','Required parameter requestParameters.userSignInRequest was null or undefined when calling userSignIn.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/users/sessions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserSignInRequestToJSON(requestParameters.userSignInRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userSignIn(userSignInRequest: UserSignInRequest): Promise<void> {
        await this.userSignInRaw({ userSignInRequest: userSignInRequest });
    }

    /**
     */
    async userSignOutRaw(requestParameters: UserSignOutRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.signOutRequest === null || requestParameters.signOutRequest === undefined) {
            throw new runtime.RequiredError('signOutRequest','Required parameter requestParameters.signOutRequest was null or undefined when calling userSignOut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/users/sessions`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: SignOutRequestToJSON(requestParameters.signOutRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userSignOut(signOutRequest: SignOutRequest): Promise<void> {
        await this.userSignOutRaw({ signOutRequest: signOutRequest });
    }

}
